const handleVimeoBackgroundVideo = () => {
    const $vimeoVideos = $('.js-vimeo-background');

    if ($vimeoVideos.length) {
        $vimeoVideos.each(function() {
            let $this = $(this);

            let player = new Vimeo.Player($this, {
                url: $this.data('video-url'),
                autoplay: true,
                background: true,
                loop: true,
                muted: true
            });

            const onPlay = function() {
                player.play();
            }

            player.on('pause', onPlay);
        });
    }
}

handleVimeoBackgroundVideo();
